const internshipNavData = [
    {id: 1, link: '/', title: 'Home'},
    {id: 2, link: '#header', title: 'Overview'},
    {id: 3, link: '#highlights', title: 'Highlights'},
    {id: 4, link: '#tools', title: 'Tools Covered'},
    {id: 5, link: '#program-details', title: 'Program Details'},
    {id: 6, link: '#who', title: 'Who Should Apply'},
    {
        id: 7, 
        title: 'More Programs',
        submenu: [
            {
                id: 71, 
                link: '/virtual-internship/data-science', 
                title: 'Data Science'
            },
            //Add more internship programs here as they become available
            {
                id: 72, 
                link: '/virtual-internship/data-analytics', 
                title: 'Data Analytics'
            },
            {
                id: 73, 
                link: '/virtual-internship/data-engineering', 
                title: 'Data Engineering'
            },
        ]
    },
]

export default internshipNavData;
